'use es6';

import * as RequestState from 'FormsCommonComponents/lib/RequestState';
import * as Actions from 'FormsCommonComponents/actions/LegalConsent';
const intialState = {
  subscriptionDefinitions: [],
  subscriptionDefinitionsRequestState: RequestState.NOT_REQUESTED,
  consentCopy: {},
  consentCopyRequestState: RequestState.NOT_REQUESTED
};
export function legalConsent(state = intialState, action) {
  switch (action.type) {
    case Actions.REQUEST_SUBSCRIPTION_DEFINITIONS:
      return Object.assign({}, state, {
        requestState: RequestState.REQUESTED
      });
    case Actions.RETRIEVED_SUBSCRIPTION_DEFINITIONS:
      return Object.assign({}, state, {
        subscriptionDefinitions: action.definitions.subscriptionDefinitions,
        subscriptionDefinitionsRequestState: RequestState.SUCCEEDED
      });
    case Actions.FAIL_RETRIEVED_SUBSCRIPTION_DEFINITIONS:
      return Object.assign({}, state, {
        subscriptionDefinitions: [],
        subscriptionDefinitionsRequestState: RequestState.FAILED
      });
    case Actions.REQUEST_CONSENT_COPY:
      return Object.assign({}, state, {
        consentCopyRequestState: RequestState.REQUESTED
      });
    case Actions.RETRIEVED_CONSENT_COPY:
      return Object.assign({}, state, {
        consentCopy: action.consentCopy,
        consentCopyRequestState: RequestState.SUCCEEDED
      });
    case Actions.FAIL_RETRIEVED_CONSENT_COPY:
      return Object.assign({}, state, {
        consentCopy: {},
        consentCopyRequestState: RequestState.FAILED
      });
    default:
      return state;
  }
}